module.exports = __webpack_public_path__ + "assets/foralder-malin-stockholm.6e9c3655.jpg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/homepage/foralder-malin-stockholm.jpg
// module id = 1643
// module chunks = 10